<template>
  <el-dialog
    :title="edit.isEdit ? '编辑' : '新增'"
    :visible.sync="edit.visible"
    @open="onDialogOpen"
  >
    <el-form
      ref="form"
      :model="edit.data"
      :rules="rules"
      label-width="150px"
      style="width: 400px"
      @submit="onSubmit"
    >
      <el-form-item label="所属" v-if="edit.params">
        <el-tag>{{ edit.params.name }}</el-tag>
      </el-form-item>
      <el-form-item label="名称" prop="name">
        <el-input v-model.trim="edit.data.name" />
      </el-form-item>
    </el-form>

    <div slot="footer">
      <el-button @click="edit.visible = false"> 取消 </el-button>
      <el-button type="primary" @click="onSubmit"> 保存 </el-button>
    </div>
  </el-dialog>
</template>

<script lang="ts">
import store from './tag.store'
import { MessageBoxService } from '../../admin-shared-modules/utils/message-box.service'
import { AJAXErrorResult } from '../../admin-shared-modules/utils/ajax'

export default {
  data() {
    return {
      edit: store.edit,
      list: store.list,
      rules: {
        name: [
          { required: true, message: '请填写' },
          { min: 2, message: '长度需大于 2' }
        ]
      }
    }
  },

  methods: {
    onDialogOpen() {
      this.$nextTick(() => {
        this.$refs['form'].clearValidate()
      })
    },

    onSubmit() {
      this.$refs['form'].validate(v => {
        if (!v) return
        this.list.tagGroup.currentId = 0
        store.onEditSubmit()
        store.fetch()
      })
    }
  }
}
</script>
